import { t } from '../lib/i18n'
import { app, authentication } from '@microsoft/teams-js'

export async function signInWithTeamsSso(context) {
  const microsoftToken = await authentication.getAuthToken()
  const result = await teamsRequest('/teams/sso', microsoftToken, 'POST')
  if (!result.token || result.tenant_id !== context.user?.tenant?.id) throw new Error(t("Dit account hoort bij een andere Microsoft-organisatie. Meld aan met een account uit dit Team."))
  return result.token
}
export async function signInToTeams(context, editing = false) {
  const nonce = Array.from(crypto.getRandomValues(new Uint8Array(32)), value => value.toString(16).padStart(2, '0')).join('')
  const result = JSON.parse(await authentication.authenticate({ url: `${location.origin}/teams/auth/start?nonce=${nonce}${editing ? '&editing=1' : ''}`, width: 600, height: 640 }))
  if (result.nonce !== nonce || !result.token) throw new Error(t("De aanmelding kon niet worden bevestigd. Probeer opnieuw."))
  if (context.user?.tenant?.id && result.tenant_id !== context.user.tenant.id) throw new Error(t("Dit account hoort bij een andere Microsoft-organisatie. Meld aan met een account uit dit Team."))
  return result.token
}
export async function teamsRequest(path, token, method = 'GET', payload) {
  let response
  try { response = await fetch(path, { method, headers: { Accept: 'application/json', Authorization: `Bearer ${token}`, ...(payload ? { 'Content-Type':'application/json' } : {}) }, credentials: 'omit', ...(payload ? { body:JSON.stringify(payload) } : {}) }) }
  catch { throw new Error(t("Microsoft kon niet worden bereikt. Probeer opnieuw.")) }
  const fail = (message, code) => { const error = new Error(message); error.status = response.status; error.code = code; throw error }
  if (response.status === 401) fail(t("Je sessie is verlopen. Meld opnieuw aan."))
  if (response.status === 403) fail(t("Je hebt nog geen actieve toegang tot Heliview Kanban. Vraag je appbeheerder om toegang."))
  if (response.status === 404) fail(t("Deze gedeelde view is niet beschikbaar voor jouw organisatie."))
  if (response.status === 204) return null
  const body = await response.json().catch(() => ({}))
  if (!response.ok) fail(body.error || t("Ophalen is niet gelukt."), body.code)
  return body
}
export async function teamsContext() {
  await app.initialize()
  return app.getContext()
}
